import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./styles.scss";
import styles from "./index.module.scss";

import SideMenu from "./components/SideMenu";
import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import TooltipModal from "./components/tooltip/TooltipModal";
import PopupModal from "./components/popup/PopupModal";
import Modal from "./components/model/Modal";

const PaymentsPage = React.lazy(() =>
  import(
    /* webpackChunkName: 'PaymentsPage', webpackPrefetch: true */ "./pages/PaymentsPage"
  )
);
const ProductsPage = React.lazy(() =>
  import(
    /* webpackChunkName: 'ProductsPage', webpackPrefetch: true */ "./pages/ProductsPage"
  )
);
const CustomersPage = React.lazy(() =>
  import(
    /* webpackChunkName: 'CustomersPage', webpackPrefetch: true */ "./pages/CustomersPage"
  )
);
const SearchPage = React.lazy(() =>
  import(/* webpackChunkName: 'SearchPage', webpackPrefetch: true */ "./pages/SearchPage")
);

function App() {
  return (
    <>
      <div className={styles.container}>
        <Router>
          <div className={styles.sideMenu}>
            <SideMenu />
          </div>

          <div className={styles.content}>
            <Header />

            <div className={styles.pageWrapper}>
              <Suspense fallback={<div></div>}>
                <Switch>
                  <Route path="/payments">
                    <PaymentsPage />
                  </Route>

                  <Route path="/products">
                    <ProductsPage />
                  </Route>

                  <Route path="/customers">
                    <CustomersPage />
                  </Route>

                  <Route path="/search">
                    <SearchPage />
                  </Route>

                  <Route path="/">
                    <HomePage />
                  </Route>
                </Switch>
              </Suspense>
            </div>
          </div>
        </Router>
      </div>

      <div></div>
      <div className={styles.layerContainer}>
        <TooltipModal />
        <PopupModal />
        <Modal />
      </div>
      <div></div>
    </>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
